import { useEffect } from "react";
import "./style/RelifeOurApproach.css";
import { NavLink, Link } from "react-router-dom";

export default function RelifeOurApproach() {
  return (
    <>
      <section className="final-cta-section">
        <h2 className="final-cta-headline">Start with one honest answer.</h2>
        <p className="final-cta-body">
          Sometimes the first relief is not fixing everything. Sometimes it is
          finally understanding what has been happening inside you. .
          <br />
          <em>
            You only need one quiet moment where you stop avoiding what you
            already feel.
          </em>
        </p>
        <div className="final-cta-btns">
          <a href="/session">
            <button
              className="btn-dark-primary"
              data-testid="button-final-begin"
            >
              Begin now →
            </button>
          </a>
        </div>
      </section>
    </>
  );
}
